import { createSlice } from '@reduxjs/toolkit';

import axios from 'axios';
import { dispatch } from '../index';

const initialState = {
    error: null,
    campaignInfo: null,
    uploadImgPath: null,
    uploadProdPath: null,
    subscribedCreativeTopic: false,
    creatorResultProgress: null,
    creatorResultFailedGeneration: null
};

// ==============================|| SLICE - CREATOR ||============================== //

const slice = createSlice({
    name: 'smartCreatorEdit',
    initialState,
    reducers: {
        hasError(state, action) {
            if(action.payload.response ? (action.payload.response.status == 401) : (action.payload.status == 401)) {
                window.location.pathname = 'login'
            } else {
                state.error = action.payload;
            }
        },
        setUploadImgPath(state, action) {
            state.uploadImgPath = action.payload;
        },
        resetUploadImgPath(state) {
            state.uploadImgPath = null;
        },
        setUploadProdPath(state, action) {
            state.uploadProdPath = action.payload;
        },
        resetUploadProdPath(state) {
            state.uploadProdPath = null;
        },
        setCreatorResultProgress(state, action) {
            state.creatorResultProgress = action.payload;
        },
        setCreatorResultFailedGeneration(state, action) {
            state.creatorResultFailedGeneration = action.payload;
        },
        setSubscribedCreatorCreativeTopic(state, action) {
            state.subscribedCreativeTopic = action.payload;
        },
        setCampaignInfo(state, action) {
            state.campaignInfo = action.payload;
            state.creatorResultProgress = action.payload.imageProgress
        },
        resetStore(state) {
            state.error = null;
            state.campaignInfo = null;
            state.uploadImgPath = null;
            state.uploadProdPath = null;
            state.creatorResultProgress = null;
            state.creatorResultFailedGeneration = null;
        }
    }
});

export default slice.reducer;

export const {
    setSubscribedCreatorCreativeTopic,
    setCreatorResultProgress,
    setCreatorResultFailedGeneration
} = slice.actions;

// An action to start stomp connection.
export const connectStomp = (gentype, id) => ({ type: 'connect', gentype, id });

// An action to disconnect stomp connection.
export const disconnectStomp = () => ({ type: 'disconnect' });

// An action to unsubscribe stomp topic.
export const unsubscribeTopic = (gentype, id) => ({ type: 'unsubscribe', gentype, id});

export function clearStore(data, callback) {
    return () => {
        dispatch(slice.actions.resetStore());
        if (callback) {
            callback();
        }
    };
}

export function bgImageUpload(data, callback) {
    return async () => {
        try {
            const response = await axios.post('/api/file/upload/temp', data, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
                    'Content-Type': 'multipart/form-data'
                }
            });
            dispatch(slice.actions.setUploadImgPath(response.data));
            if (callback) {
                callback();
            }
        } catch (e) {
            dispatch(slice.actions.hasError(e));
        }
    };
}

export function revertBgUploadImage(data, callback) {
    return () => {
        dispatch(slice.actions.setUploadImgPath(data));
        if (callback) {
            callback();
        }
    }
}

export function removeBgUploadImage(data, callback) {
    return () => {
        dispatch(slice.actions.resetUploadImgPath());
        if (callback) {
            callback();
        }
    };
}

export function prodImageUpload(data, callback) {
    return async () => {
        try {
            const response = await axios.post('/api/file/upload/temp', data, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
                    'Content-Type': 'multipart/form-data'
                }
            });
            dispatch(slice.actions.setUploadProdPath(response.data));
            if (callback) {
                callback();
            }
        } catch (e) {
            dispatch(slice.actions.hasError(e));
        }
    };
}

export function getCampaignDetail(data, callback) {
    return async () => {
        try {
            const response = await axios.get(`/api/smart-campaign/details/${data}`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
                    'X-Workspace-ID': localStorage.getItem('workspaceId')
                }
            });
            dispatch(slice.actions.setCampaignInfo(response.data.smartCampaign));
            if (callback) {
                callback();
            }
        } catch (e) {
            dispatch(slice.actions.hasError(e));
        }
    }
}

export function createCampaign(data, callback) {
    return async () => {
        try {
            const response = await axios.post('/api/smart-campaign/create', data, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
                    'X-Workspace-ID': localStorage.getItem('workspaceId')
                }
            });
            dispatch(slice.actions.setCampaignInfo(response.data.smartCampaign));
            if (callback) {
                callback();
            }
        } catch (e) {
            dispatch(slice.actions.hasError(e));
        }
    }
};

export function updateCampaign(data, callback) {
    return async () => {
        try {
            const response = await axios.post('/api/smart-campaign/update', data, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
                    'X-Workspace-ID': localStorage.getItem('workspaceId')
                }
            });
            dispatch(slice.actions.setCampaignInfo(response.data.smartCampaign));
            if (callback) {
                callback();
            }
        } catch (e) {
            dispatch(slice.actions.hasError(e));
        }
    }
};

export function regenerateCampaign(data, callback) {
    return async () => {
        try {
            const response = await axios.post('/api/smart-campaign/regenerate', data, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
                    'X-Workspace-ID': localStorage.getItem('workspaceId')
                }
            });
            dispatch(slice.actions.setCampaignInfo(response.data.smartCampaign));
            if (callback) {
                callback();
            }
        } catch (e) {
            dispatch(slice.actions.hasError(e));
        }
    }
};

export function revertProdUploadImage(data, callback) {
    return () => {
        dispatch(slice.actions.setUploadProdPath(data));
        if (callback) {
            callback();
        }
    }
}

export function removeProdUploadImage(data, callback) {
    return () => {
        dispatch(slice.actions.resetUploadProdPath());
        if (callback) {
            callback();
        }
    };
}
